export default __webpack_public_path__ + "static/1-be27392634e44aa521d8df5484fdcf5d.png";